import { $FixMe } from '@eventbrite/ts-utils';
import loadable from '@loadable/component';
import React from 'react';
import FilterPanel from './FilterPanel';

const BotFilters = loadable(() => import('../BotFilters'), {
    resolveComponent: (component: { BotFilters: React.ReactNode }) =>
        component.BotFilters,
});

export const FilterPanelDesktop = (props: {
    isBotRequest?: boolean;
    locationSlug: string;
    onFilterChange?: Function;
    handleDrawerSelect?: Function;
    handleRemoveAllFilters?: Function;
    handleRemoveFilter?: Function;
    isLoading?: boolean;
    filterTypeToShow?: $FixMe;
    selectedFilters?: string[];
}) => {
    if (props.isBotRequest) {
        return <BotFilters slug={props.locationSlug} />;
    }

    const handleFilterChange = (...args: any) => {
        props.onFilterChange?.(...args);
        props.handleDrawerSelect?.('');

        // Scroll back to top of screen, otherwise
        // it looks strange
        window.scrollTo(0, 0);
    };

    return (
        <FilterPanel
            {...props}
            style={{ maxWidth: '320px' }}
            onFilterChange={handleFilterChange}
        />
    );
};
